import { BASE_URL } from 'config';
import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, CircularProgress, Box } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function ExclusionsSection({ exclusions, setExclusions }) {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchOffers();
  }, []);

  const fetchOffers = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("user-token");
      const response = await fetch(
        BASE_URL + "/administrator/promotions",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (data.status && Array.isArray(data.data)) {
        setOffers(data.data);
      } else {
        setOffers([]);
      }
    } catch (error) {
      setOffers([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MDBox
      display="flex"
      flexDirection="column"
      gap={2}
      p={3}
      boxShadow={3}
      borderRadius="16px"
      bgcolor="#fff"
      mb={4}
      sx={{ width: "90%", margin: "20px auto" }}
    >
      <MDTypography variant="h6" color="text" fontWeight="medium" mb={1}>
        الاستثناءات
      </MDTypography>
      <Autocomplete
        multiple
        options={offers}
        getOptionLabel={(option) => option.name || `عرض رقم ${option.id}`}
        value={exclusions}
        onChange={(_, newValue) => setExclusions(newValue)}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            label="اختر العروض المستثناة"
            placeholder="بحث..."
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        sx={{ minWidth: 300 }}
      />
    </MDBox>
  );
}

export default ExclusionsSection;
